/* eslint-disable */
$(function() {
  if ($("body").hasClass("home")) {

    // JavaScript to be fired on all pages
    $(".c-fullpage-section").fullpage({
      navigation: false,
      autoScrolling: true,
      licenseKey: 'D03D1D34-66F74BAF-AB6166BE-C80FB323',
      scrollOverflow: true,
      scrollOverflowOptions: {
        preventDefault: false
      },
      mousewheel: true,
      paddingTop: 0,
      paddingBottom: 0,
      verticalCentered: true,
      scrollBar: false,
      fitToSection: true,
      afterLoad: function(anchorLink, index) {
        var iscrollLastSection = $('.fp-section.c-home-content-section').find('.fp-scrollable').data('iscrollInstance');
        var numSections = $('.fp-section').length;
        if (index == 1) {
          $(this).find('.c-home-slide__caption').addClass('is-shown');
        }
        if (index == numSections - 1) {
          $('.c-lined-grid--news').css({
            height: $('.c-lined-grid--news').height() + 'px'
          });
        }
        if (index == numSections - 2) {
          if (iscrollLastSection && typeof iscrollLastSection !== undefined) {
            setTimeout(function() {
              iscrollLastSection.refresh();
            }, 0);
            $('.c-newsletter-link').one('click', function(e){
              e.preventDefault();
              $('.c-newsletter-dropdown').slideDown(0);
              setTimeout(function() {
                iscrollLastSection.refresh();
                iscrollLastSection.scrollBy(0, -250, 250, IScroll.utils.ease.quadratic);
              }, 50);
              $(this).data('clicked', true);
            });
          }
        }
        if (index == 1 && !$('.c-newsletter-link').data('clicked')) {
          if ($('.c-newsletter-link').length > 0) {
            $('.c-newsletter-dropdown').slideUp(250);
          }
        }
        $('body').removeClass('is-white');
        $('#back-slide-one').on('click', function(){
          $.fn.fullpage.moveTo(1);
        });
        if (index === $('.c-fullpage-section .section').length) {
          $('body.home .c-main-header').addClass('is-white');
        } else {
          $('body.home .c-main-header').removeClass('is-white');
        }

        if ($(this).hasClass('c-home-slide')) {
          if ($(this).attr('data-color') == 'White') {
            $('body').addClass('is-white');
          }
        }
        $('.c-fullpage-section').css({
          transform: 'translate3d(0, 0, 0)'
        });
      },
      onLeave: function(index, nextIndex, direction){
        $(this).next().find('.c-home-slide__caption').addClass('is-shown');
        if (direction == "up") {
          $(".section").removeClass("down");
          $(".section").removeClass("next");
          $(".section").removeClass("prev");
          $(".c-fullpage-section .section:nth-child("+nextIndex+")").addClass("up");
          $(".c-fullpage-section .section:nth-child("+nextIndex+")").next().addClass("next up");
          $(".c-fullpage-section .section:nth-child("+nextIndex+")").prev().addClass("prev up");
        } else {
          $(".section").removeClass("up");
          $(".section").removeClass("next");
          $(".section").removeClass("prev");
          $(".c-fullpage-section .section:nth-child("+nextIndex+")").addClass("down");
          $(".c-fullpage-section .section:nth-child("+nextIndex+")").next().addClass("next down");
          $(".c-fullpage-section .section:nth-child("+nextIndex+")").prev().addClass("prev down");
        }
      },
    });

    $.fn.fullpage.setAllowScrolling(true);
    $.fn.fullpage.reBuild();

    $(document).on('click', '.c-pagination a', function(event) {
      event.preventDefault();
      var newsHeight = $('.c-lined-grid--news').height();
      var link = $(this).attr('href');
      $('.c-news-links').fadeOut("slow").load(link+' .c-news-links', { async: false }, function(){
        $('.c-lined-grid--news').css({
          height: newsHeight + 'px'
        });
      }).fadeIn('slow');
    });

  } else {
    if ($('.c-newsletter-link').length > 0) {
      $('.c-newsletter-link').one('click', function(e){
        e.preventDefault();
        $('.c-newsletter-dropdown').slideDown(0);
        setTimeout(function() {
          $('html, body').animate({
            scrollTop: $('.c-newsletter-dropdown').offset().top
          }, 250);
        }, 50);
      });
    }
  }
});

export default {
  init() {


    // ACCORDION TOGGLE
    $(".o-accordion").each(function() {
      $(this).find('.o-accordion__toggle').mouseenter(function(){
        $(this).parent().parent().siblings().css('z-index', 2);
      });
      $(this).find('.o-accordion__toggle').mouseleave(function(){
        $(this).parent().parent().siblings().css('z-index', 1);
      });
      $(this)
        .find(".o-accordion__toggle")
        .on("click", function() {
          // var thisID = $( this ).attr( 'id' );
          // var tempID = thisID.split( '-' );
          // var theID = tempID[ 2 ]; // GET CORRESPONDING COUNTER
          if ($(this).attr("aria-expanded") == "false") {
            $(this)
              .parent()
              .parent()
              .parent()
              .parent()
              .parent()
              .find(".o-accordion__toggle")
              .attr("aria-expanded", "false");
            $(this).attr("aria-expanded", "true");
            $(this)
              .siblings(".o-accordion__icon")
              .html("&plus;");
            $(this)
              .siblings(".o-accordion__icon_")
              .html("View Details");
            $(this)
              .parent()
              .parent()
              .parent()
              .parent()
              .parent()
              .find(".o-accordion__icon")
              .html("&plus;");
            $(this)
              .parent()
              .parent()
              .parent()
              .parent()
              .parent()
              .find(".o-accordion__icon_")
              .html("View Details");
            $(".o-accordion__content").slideUp(500).removeClass('is-active');
            $(this)
              .find(".o-accordion__icon")
              .html("&plus;");
            $(this)
              .find(".o-accordion__icon_")
              .html("Hide Details");
            $(this)
              .parent()
              .parent()
              .find(".o-accordion__content")
              .slideDown(500)
              .addClass('is-active');
          } else {
            $(this).attr("aria-expanded", "false");
            $(this)
              .find(".o-accordion__icon")
              .html("&plus;");
            $(this)
              .find(".o-accordion__icon_")
              .html("View Details");
            $(".o-accordion__content").slideUp(500).removeClass('is-active');
          }
        });
    });

    function slickMultipleCarousel() {
      $(".c-slick-slider").slick({
        dots: false,
        infinite: true,
        speed: 500,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '20%'
      });
    }

    function slickSingleCarousel() {
      $(".c-slick-single-slider").slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: false,
        centerPadding: 0,
        responsive: [
          {
            breakpoint: 850,
            settings: {
              prevArrow: $('.c-slide__mobile-arrow')
            }
          }
        ]
      });
    }

    if ($.fn.slick) {
      slickMultipleCarousel();
      slickSingleCarousel();
    }

    if ( window.location.hash == '#careers' ) {
      var hash = window.location.hash,
          $hash = $(hash);
      $hash.removeAttr('id');
      $hash.before('<div id="'+hash.slice(1)+'" class="o-hashlink"></div>');
      window.location.hash = hash;
    }

    const observer = lozad('.lozad', {
      load: function(el) {
        el.classList.add('fade');
      },
      rootMargin: '300px 0px',
      threshold: 0.3
    });
    observer.observe();

    function gridMasonry() {
      $('.l-project-grid').masonry({
        // options
        itemSelector: '.l-project-grid-item',
        percentPosition: true,
        gutter: 50,
        columnWidth: '.l-project-grid-item--size'
      });
    }

    if ($('.l-project-grid').length > 0) {
      $(window).load(gridMasonry);
    }

    // Smooth scrolling on anchor clicks
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ?
          target :
          $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html, body").animate({
              scrollTop: target.offset().top - 75
            },
            1000
          );
          return false;
        }
      }
    });

    var pageType = $('body').attr('data-page');

    function titleScroll() {
      var prevScrollpos = window.pageYOffset,
          siteHeader = document.querySelector('.c-main-header'),
          hero = $('.c-hero'),
          logoGroup = $('.c-main-header__logos'),
          projectTitle = $('.c-main-header__project'),
          siteHeaderHeight = siteHeader.offsetHeight,
          heroOffsetHeight = hero.offset().top - $(window).scrollTop()

      document.addEventListener('scroll', () => {

        // When the user scrolls down, show the project title.
        // When the user scrolls up, hide the project title.
        var currentScrollPos = window.pageYOffset,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            console.log(scrollTop);
        if (scrollTop > heroOffsetHeight && scrollTop != 0) {
          projectTitle.addClass('is-shown');
          logoGroup.addClass('project-title-is-shown');
        }
        else {
          projectTitle.removeClass('is-shown');
          logoGroup.removeClass('project-title-is-shown');
        }

      });
    }

    function playVideoPromise() {
      $('video.is-autoplay').each(function() {
        var playPromise = $(this)[0].play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            // Automatic playback started!
            // Show playing UI.
          })
          .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
          });
        }
      });
    }

    function videoScrollPlay() {
      $(window).scroll(function() {
        $('video.is-autoplay').each(function() {
          if ($(this).visible(true)) {
            $(this)[0].play();
          } else {
            $(this)[0].pause();
          }
        })
      });
    }

    function playVideoManually() {
      $('.c-video-block').each(function() {
        var icon = $(this).find('.c-video-block__icon');
        var video = $(this).find('video')[0];
        if (icon.length > 0) {
          $(this).find('.c-video-block__icon').on('click', function(e){
            video.play();
            $(this).parent().find('video').attr('controls', '');
            $(this).remove();
            e.stopPropagation();
          });
          return true;
        }
      });
    }

    function ajaxNextPost() {
      $(document).on('click', '.c-next-project-section', function(event) {
        event.preventDefault();
        $('body').addClass('is-animating-body');
        $('.c-main-header__project').addClass('is-animating-project-title');
        $(this).addClass('is-animating-next-section');
        $(this).addClass('is-fixed');
        $(this).prev().addClass('is-animating-current-section');
        $(this).one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function(e) {
          $('body').removeClass('is-animating-body');
          var link = $('.c-next-project-section').attr('href');
          $('.l-main').load(link+' .c-projects-container', { async: false }, function(){
            $('.c-main-header__project').removeClass('is-animating-project-title is-shown');
            $('.c-next-project-section').removeClass('is-fixed');
            $('html').scrollTop(0);
            $('.c-main-header__project').html('+ ' + $('.c-project').attr('data-title'));
            $(document).prop('title', $('.c-project').attr('data-title') + ' - Aruliden')
            $(window).on('popstate', function (e) {
              location.reload();
            });
            const observer = lozad('.lozad', {
              load: function(el) {
                el.classList.add('fade');
              },
              rootMargin: '300px 0px',
              threshold: 0.3
            });
            observer.observe();
            playVideoManually();
            playVideoPromise();
            slickMultipleCarousel();
            slickSingleCarousel();
            history.pushState(null, null, link);
          });
        });
      });
    }

    if ($("body").hasClass("work") || $("body").hasClass("single-project")) {
      const swupOptions = {
        linkSelector: 'a.u-swup-link'
      }
      const swup = new Swup(swupOptions);

      document.addEventListener('swup:animationInStart', (event) => {
        if (pageType == 'page') {
          $('html').addClass('is-animating-to-black');
        }
      });

      document.addEventListener('swup:pageView', (event) => {
        if (pageType == 'page') {
          $('body').attr('data-page', 'project');
          $('footer.c-main-footer').hide();
          $('html, body').animate({ scrollTop: 0 }, 0);
          $('.c-main-header__project').html('+ ' + $('.c-project').attr('data-title'));
          if ($('.c-hero').length > 0) {
            titleScroll();
          }
          playVideoPromise();
          videoScrollPlay();
          const observer = lozad('.lozad', {
            load: function(el) {
              el.classList.add('fade');
            },
            rootMargin: '300px 0px',
            threshold: 0.3
          });
          observer.observe();
          playVideoManually();
          slickMultipleCarousel();
          slickSingleCarousel();
          ajaxNextPost();
        }
        if (window.location.pathname == '/work/') {
          $('body').attr('data-page', 'page');
          $('footer.c-main-footer').show();
          $('html').removeClass('is-animating-to-black');
          $('.c-main-header__project').removeClass('is-animating-project-title is-shown');
          gridMasonry();
        }
      });
    }

    /**
     * General helper function to support toggle functions.
     */
    var toggleClasses = function(element) {
      var $this = element,
          $togglePrefix = $this.data('prefix') || 'this';

      // If the element you need toggled is relative to the toggle, add the
      // .js-this class to the parent element and "this" to the data-toggled attr.
      if ($this.data('toggled') == "this") {
        var $toggled = $this.closest('.js-this');
      }
      else {
        var $toggled = $('.' + $this.data('toggled'));
      }
      if ($this.attr('aria-expanded', 'true')) {
        $this.attr('aria-expanded', 'true')
      }
      else {
        $this.attr('aria-expanded', 'false')
      }
      $this.toggleClass($togglePrefix + '-is-active');
      $toggled.toggleClass($togglePrefix + '-is-active');

      // Remove a class on another element, if needed.
      if ($this.data('remove')) {
        $('.' + $this.data('remove')).removeClass($this.data('remove'));
      }
    };

    /*
     * Toggle Active Classes
     *
     * @description:
     *  toggle specific classes based on data-attr of clicked element
     *
     * @requires:
     *  'js-toggle' class and a data-attr with the element to be
     *  toggled's class name both applied to the clicked element
     *
     * @example usage:
     *  <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
     *  <div class="toggled-class">This element's class will be toggled</div>
     *
     */
    $('.js-toggle').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    // Toggle parent class
    $('.js-toggle-parent').on('click', function(e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('this-is-active');
      $this.parent().toggleClass('this-is-active');
    });

    // Prevent bubbling to the body. Add this class to the element (or element
    // container) that should allow the click event.
    $('.js-stop-prop').on('click', function(e) {
      e.stopPropagation();
    });

    // Toggle hovered classes
    $('.js-hover').on('mouseenter mouseleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    $('.js-hover-parent').on('mouseenter mouseleave', function(e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('this-is-active');
      $this.parent().toggleClass('this-is-active');
    });

    if ($('.u-match-height').length > 0) {
      $(function() {
        $('.u-match-height').matchHeight({
          byRow: false
        });
      });
    }


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired





  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js